import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const listServiceService = {
  get_all: async (search = "", token) => {
    const response = await https.get(
      `${API_ROUTES.LIST_SERVICE.GET_ALL}?search_value=${search}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_all_category: async (token) => {
    const response = await https.get(
      `${API_ROUTES.LIST_SERVICE.GET_ALL_CATEGORY}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_service_by_category: async (category_id, token) => {
    const response = await https.get(
      `${API_ROUTES.LIST_SERVICE.GET_ALL_CATEGORY}/${category_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_service_by_id: async (service_id, token) => {
    const response = await https.get(
      `${API_ROUTES.LIST_SERVICE.GET_SERVICE_BI_ID}/${service_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
};
